import { useQuery } from '@tanstack/react-query'

import { getOrganizationCreateRequests } from '@src/api'
import { DefaultApiGetOrganizationCreateRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganizationCreateRequests = (
  params: DefaultApiGetOrganizationCreateRequestsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params,
    queryFn: () => getOrganizationCreateRequests(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_ZEUS_ORGANIZATION_CREATE_REQUESTS,
      params,
    ],
  })
}
